export function detectDevicesAndBrowser() {

    const $body = $("body");
    const $window = $(window);

    isTouch();
    isSafari();
    isIE();

    function isTouch() {
        return "ontouchstart" in window ? $body.addClass("touch") : $body.addClass("no-touch");
    }

    function isSafari() {
        if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            $body.addClass("safari");
        }
    }

    function isIE() {
        if(navigator.userAgent.match(/Trident\/7\./)) {
            document.body.addEventListener("mousewheel", function (event) {
                event.preventDefault();
                let wheelDelta = event.wheelDelta;
                let currentOffset = window.pageYOffset;
                window.scrollTo(0, currentOffset - wheelDelta);
            });
        }
    }

    (function () {
        let html = $("html");

        if (!(window.ActiveXObject) && "ActiveXObject" in window && html.height() === $(window).height()) {
            html.css("height", "100%");
        }
    })();

    $window.on("load", () => {
        $body.addClass("load");
    });
}




// WEBPACK FOOTER //
// ./assets/js/modules/module.js